import { useMemo } from 'react';
import { SortDirection, sortBy } from '@betgames/bg-tools';
import { GamesContexts, lotterySelectors } from '@bg-shared/contexts/Games';
import { ILotteryContext } from '@bg-shared/contexts/Games/Lottery/interfaces';
import { GameId } from '@bg-shared/enums/GameId';

export const useMinMaxMultipliers = (gameId: GameId, oddsId: number) => {
    const Context = GamesContexts.useContexts()[gameId] as ILotteryContext;
    const multipliers = Context.useSelector(lotterySelectors.getMultipliers(oddsId));

    const sortedMultipliers = useMemo(
        () =>
            [...multipliers]
                .sort(sortBy((item) => item.multiplier, SortDirection.ASC))
                .map((item) => item.multiplier),
        [multipliers.toString()],
    );

    return [sortedMultipliers[0], sortedMultipliers[sortedMultipliers.length - 1]];
};
